import React from 'react';

// Íconos del canvas (trazo 2px, 24x24). Son funciones y no componentes para
// poder pasarlos inline sin props opcionales.
type IconOptions = {
  size?: number;
  color?: string;
  strokeWidth?: number;
  style?: React.CSSProperties;
  className?: string;
};

const svg = (paths: React.ReactNode, options: IconOptions = {}) => {
  const {
    size = 20, color = 'currentColor', strokeWidth = 2, style, className,
  } = options;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      style={{ flexShrink: 0, ...style }}
      className={className}
    >
      {paths}
    </svg>
  );
};

export const arrowRightIcon = (o?: IconOptions) => svg(
  <>
    <path d="M5 12h14" />
    <path d="M13 6l6 6-6 6" />
  </>,
  o,
);

export const chevronLeftIcon = (o?: IconOptions) => svg(<path d="M15 6l-6 6 6 6" />, o);

export const chevronRightIcon = (o?: IconOptions) => svg(<path d="M9 6l6 6-6 6" />, o);

export const chevronDownIcon = (o?: IconOptions) => svg(<path d="M6 9l6 6 6-6" />, o);

export const clockIcon = (o?: IconOptions) => svg(
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </>,
  o,
);

export const shieldCheckIcon = (o?: IconOptions) => svg(
  <>
    <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z" />
    <path d="M9 12l2 2 4-4" />
  </>,
  o,
);

export const eyeIcon = (o?: IconOptions) => svg(
  <>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
  </>,
  o,
);

export const eyeOffIcon = (o?: IconOptions) => svg(
  <>
    <path d="M3 3l18 18" />
    <path d="M10.6 5.1A9.8 9.8 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-3.2 4.1" />
    <path d="M6.6 6.6C3.8 8.4 2 12 2 12s3.5 7 10 7c1.6 0 3-.4 4.3-1" />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
  </>,
  o,
);

export const mailIcon = (o?: IconOptions) => svg(
  <>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 7l9 6 9-6" />
  </>,
  o,
);

export const homeIcon = (o?: IconOptions) => svg(
  <>
    <path d="M3 11l9-7 9 7" />
    <path d="M5 10v10h14V10" />
  </>,
  o,
);

export const personAddIcon = (o?: IconOptions) => svg(
  <>
    <circle cx="9" cy="8" r="4" />
    <path d="M2 21c.9-4 3.8-6 7-6s6.1 2 7 6" />
    <path d="M19 8v6M16 11h6" />
  </>,
  o,
);

export const alertCircleIcon = (o?: IconOptions) => svg(
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7.5v5.5" />
    <path d="M12 16.5h.01" />
  </>,
  o,
);

export const fileTextIcon = (o?: IconOptions) => svg(
  <>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 3v5h5" />
    <path d="M9 13h6M9 17h4" />
  </>,
  o,
);

export const checkCircleIcon = (o?: IconOptions) => svg(
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M8.5 12.5l2.5 2.5 4.5-5" />
  </>,
  o,
);

export const lockIcon = (o?: IconOptions) => svg(
  <>
    <rect x="5" y="11" width="14" height="10" rx="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </>,
  o,
);

export const uploadIcon = (o?: IconOptions) => svg(
  <>
    <path d="M12 16V4" />
    <path d="M7 9l5-5 5 5" />
    <path d="M5 20h14" />
  </>,
  o,
);

export const briefcaseIcon = (o?: IconOptions) => svg(
  <>
    <rect x="3" y="7" width="18" height="13" rx="2" />
    <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
    <path d="M3 13h18" />
  </>,
  o,
);
